exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-66dd4df8] .van-grid-item .van-grid-item__content{padding:15px 0}", ""]);

// exports
